var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [_c("Title", { attrs: { title: "Limpezas não realizadas" } })],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "orders" },
          [
            _vm._l(_vm.orders, function(order) {
              return _c(
                "div",
                {
                  key: order.id,
                  staticClass: "order",
                  on: {
                    click: function($event) {
                      _vm.reschedule(order)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "order-content" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("img", {
                        attrs: {
                          src: _vm._f("profilePicture")(order.professional)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("firstName")(order.professional)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "order-count" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm._f("minOrderCount")(
                                  _vm._f("orderCount")(order.professional)
                                )
                              ) + " limpezas"
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(" realizadas")])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "duration" }, [
                        _c("img", {
                          attrs: { src: "/static/clock-outlined.svg" }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("getOrderDuration")(order)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "location" }, [
                        _c("img", { attrs: { src: "/static/pin.svg" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("getOrderAddressName")(order)))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-footer" }, [
                    _c("span", [_vm._v("reagendar")]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: "/static/basic/arrow-next.svg" }
                    })
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm.rescheduling
              ? _c("Cancellation", {
                  attrs: { order: _vm.reschedulingOrder, type: "rescheduling" },
                  on: {
                    close: function($event) {
                      _vm.rescheduling = false
                    }
                  }
                })
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("Tip", [_vm._v("Selecione a limpeza que gostaria de reagendar")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-purple",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_c("span", [_vm._v("Voltar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9b64636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b64636","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/Payables/NotProvidedPayablesList.vue
// module id = null
// module chunks = 